import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { IListState, mapToListModel, getListApiHttpParam, ExportResponse } from '@aston/foundation';
import * as AppStoreSelectors from 'apps/federation/src/app/root-store/app-store/selectors';

import { AccountingListSortProp } from '../enums';
import { IAccountingItemApi, IAccountingItemListApi } from '../models/api';
import { IAccountingItemList, IAccountingListItem } from '../models';
import { mapToAccountingItemModel } from '../functions';

@Injectable({
	providedIn: 'root'
})
export class AccountingDocumentsService {
	private http = inject(HttpClient);
	private store = inject(Store);


	getAccountingDocuments(params: IListState<AccountingListSortProp>): Observable<IAccountingItemList> {
		const httpParams = getListApiHttpParam(params);

		return this.store.select(AppStoreSelectors.selectConfig).pipe(
			switchMap(config => this.http.get<IAccountingItemListApi>(`${config.apiUrl}/api/AccountingDocuments`, {params: httpParams}).pipe(
				map(apiModel => mapToListModel<IAccountingItemApi, IAccountingListItem>(apiModel, mapToAccountingItemModel))
			))
		);
	}

	exportAccountingList(params: IListState<AccountingListSortProp>, isSuperCustomerExport: boolean): Observable<ExportResponse> {
		const httpParams = getListApiHttpParam(params);
		return this.store.select(AppStoreSelectors.selectConfig).pipe(
			switchMap(config => this.http.get(`${config.apiUrl}/api/AccountingDocuments/export?${httpParams}&isSuperCustomerExport=${isSuperCustomerExport}`, {observe: 'response', responseType: 'blob'})),
			map(response => new ExportResponse(response))
		);
	}

	getAccountingDocumentsCount(params: IListState<AccountingListSortProp>): Observable<number> {
		const httpParams = getListApiHttpParam(params);

		return this.store.select(AppStoreSelectors.selectConfig).pipe(
			switchMap(config => this.http.get<number>(`${config.apiUrl}/api/AccountingDocuments/count`, {params: httpParams}))
		);
	}
}
